var map = {
	"./header_lang-ee.png": "5ffe",
	"./header_lang-en.png": "3c78",
	"./header_lang-lt.png": "a84d",
	"./header_lang-lv.png": "925f",
	"./header_lang-ru.png": "eea8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a2c";